import React from 'react'

const MyLabel = () => {
  return (
    <div className="h-5 mt-[5px] w-[200px] mx-2 animate-pulse bg-gray-200 shadow-lg "></div>
  )
}

export default MyLabel